<template>
  <div class="login-page">
    <div class="login-bg">
      <img class="protocol-bg" src="../assets/protocol_bg.png" alt />
      <iframe class="protocol" :src="url"></iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: "Protocol",
  computed: {
    url() {
      if (this.$route.query.type=='private') { 
         return "//static.58.com/git/teg-app-fe/wuba-questionnaire-outside/assets/private_protocal.html"
      } else {
         return "//static.58.com/git/teg-app-fe/wuba-questionnaire-outside/assets/service_protocal.html"
      }
    }
  }
};
</script>

<style lang="scss">
html,
body {
  overflow: hidden;
}
.login-page {
  min-width: 1200px;
  width: 100%;
  height: 100%;
}
.login-bg {
  width: 100%;
  height: 100%;
  background-image: url(../assets/login-bg@2x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  overflow: hidden;
  min-width: 1200px;
  .protocol {
    box-sizing: border-box;
    width: 1000px;
    height: 100%;
    background-color: #fff;
    position: absolute;
    transform: translateX(-500px);
    top: 60px;
    left: 50%;
    border-radius: 2px;
    border: none;
    padding-left: 50px;
    padding-right: 50px;
  }
   .protocol-bg {
    box-sizing: border-box;
    width: 986px;
    position: absolute;
    transform: translateX(-493px);
    left: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/protocol.vue